import { Avatar, Box, Paper, Stack, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { MemoryMessage } from "../hooks/useMemoryMessages";
import { ContactDetailModal } from "./ContactDetailModal";

interface TopContributorsSidebarProps {
  messages: MemoryMessage[];
}

export function TopContributorsSidebar({
  messages,
}: TopContributorsSidebarProps) {
  const [selectedEmail, setSelectedEmail] = useState<string | null>(null);
  const topContributors = useMemo(() => {
    const map = new Map<string, { name: string ; count: number; email: string }>();

    messages.forEach((m) => {
      const key = m.sender_email?.toLowerCase() ?? `no-email-${m.id}`;
      if (map.has(key)) {
        map.get(key)!.count += 1;
      } else {
        map.set(key, {
          name: m.sender_full_name ?? "Anonymous",
          count: 1,
          email: m.sender_email ?? "",
        });
      }
    });

    return Array.from(map.values())
      .sort((a, b) => b.count - a.count)
      .slice(0, 5);
  }, [messages]);

  return (
    <>
      <Paper sx={{ borderRadius: 3, p: 2, boxShadow: 0 }}>
        <Typography
          sx={{ fontWeight: 700, fontSize: "14px", color: "#1e293b", mb: 2 }}
        >
          Top Contributors
        </Typography>
        <Stack spacing={1.5}>
          {topContributors.map((c, index) => (
            <Stack
              key={index}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    bgcolor: "#e2e8f0",
                    color: "#64748b",
                    fontSize: "12px",
                  }}
                >
                  {c.name.charAt(0)}
                </Avatar>
                <Box>
                  <Typography
                    sx={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}
                  >
                    {c.name}
                  </Typography>
                  <Typography sx={{ fontSize: "12px", color: "#94a3b8" }}>
                    {c.count} {c.count === 1 ? "Memory" : "Memories"}
                  </Typography>
                </Box>
              </Stack>
              <Typography
                onClick={() => setSelectedEmail(c.email ?? "")}
                sx={{
                  fontSize: "12px",
                  color: "#724e41",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                View
              </Typography>
            </Stack>
          ))}
          {topContributors.length === 0 && (
            <Typography sx={{ fontSize: "12px", color: "#94a3b8" }}>
              No contributors yet
            </Typography>
          )}
        </Stack>
      </Paper>
      {selectedEmail && (
        <ContactDetailModal
          open={!!selectedEmail}
          onClose={() => setSelectedEmail(null)}
          senderEmail={selectedEmail}
          messages={messages}
        />
      )}
    </>
  );
}
